<template>
  <div
    class="obstacle"
    :class="['is-' + matchState, { 'is-active': active }]"
  >
    <span class="note-label">{{ note || '' }}</span>
  </div>
</template>

<script>
const CROSS_SEC = 5.5

function ensureKeyframes(period, cross) {
  const p = Math.max(cross + 0.5, Number(period) || cross + 0.5)
  const c = Math.max(1, Number(cross) || CROSS_SEC)
  const movePct = Math.min(95, (c / p) * 100)
  const name = 'obMove_' + Math.round(p * 100) + '_' + Math.round(c * 100)
  if (typeof document === 'undefined') return name
  if (document.getElementById('kf-' + name)) return name
  const style = document.createElement('style')
  style.id = 'kf-' + name
  // 前段过屏，后段停在左侧外并隐藏，避免无限循环时末音与下一圈首音撞在一起
  style.textContent =
    '@keyframes ' + name + '{' +
    '0%{right:-80px;opacity:1;visibility:visible;}' +
    movePct + '%{right:100%;opacity:1;visibility:visible;}' +
    (movePct + 0.01) + '%{right:-80px;opacity:0;visibility:hidden;}' +
    '100%{right:-80px;opacity:0;visibility:hidden;}' +
    '}'
  document.head.appendChild(style)
  return name
}

export default {
  props: {
    width: { type: Number, default: 30 },
    height: { type: Number, default: 40 },
    delay: { type: Number, default: 3 },
    note: { type: [String, Number], default: '' },
    matchState: { type: String, default: 'idle' },
    active: { type: Boolean, default: false },
    startDelay: { type: Number, default: 0 },
    travel: { type: Number, default: 6 },
    cross: { type: Number, default: CROSS_SEC }
  },
  methods: {
    updateData() {
      if (!this.$el) return
      if (!this.height || this.height <= 0) {
        this.$el.style.display = 'none'
        return
      }
      this.$el.style.display = 'flex'
      this.$el.style.height = this.height + 'px'
      this.$el.style.width = this.width + 'px'

      const cross = Math.max(1, Number(this.cross) || CROSS_SEC)
      const period = Math.max(cross + 0.5, Number(this.travel) || cross + 0.5)
      const startDelay = Math.max(0, Number(this.startDelay) || 0)
      const kf = ensureKeyframes(period, cross)

      this.$el.style.animation = 'none'
      void this.$el.offsetWidth
      this.$el.style.animation = kf + ' ' + period + 's linear infinite'
      this.$el.style.animationDelay = startDelay + 's'
      this.$el.style.animationFillMode = 'both'
    }
  },
  watch: {
    height() { this.updateData() },
    width() { this.updateData() },
    startDelay() { this.updateData() },
    travel() { this.updateData() },
    cross() { this.updateData() }
  },
  mounted() {
    this.updateData()
  }
}
</script>

<style>
.obstacle {
  position: absolute;
  bottom: 0;
  right: -80px;
  min-width: 14px;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, #ff6b6b 0%, #e03131 100%);
  box-shadow: 0 0 12px rgba(255, 80, 80, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  transition: background 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  will-change: right;
}

.obstacle .note-label {
  margin-top: 4px;
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  line-height: 20px;
  text-align: center;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.obstacle.is-active {
  filter: brightness(1.15);
  box-shadow: 0 0 18px rgba(125, 211, 252, 0.7);
}

.obstacle.is-hit {
  background: linear-gradient(180deg, #69db7c 0%, #2f9e44 100%);
  box-shadow: 0 0 16px rgba(64, 192, 87, 0.7);
}

.obstacle.is-high {
  background: linear-gradient(180deg, #ffd43b 0%, #f59f00 100%);
  box-shadow: 0 0 14px rgba(250, 176, 5, 0.55);
}

.obstacle.is-low {
  background: linear-gradient(180deg, #748ffc 0%, #4c6ef5 100%);
  box-shadow: 0 0 14px rgba(76, 110, 245, 0.5);
}
</style>
